export const Banner = {
  RemoteAnnouncementBanner: "remote-announcement-banner",
  SubscriptionPastDueBanner: "subscription-past-due-banner",
  SubscriptionUpcomingRenewalBanner: "subscription-upcoming-renewal-banner",
  SubscriptionTrialBanner: "subscription-trial-banner",
  LaunchBanner: "launch-banner",
  HyroxConditioningTestBanner: "hyrox-conditioning-test-banner",
  HyroxOutputTiersBanner: "hyrox-output-tiers-banner",
} as const;

/**
 * Banner priority, highest priority first
 *
 * @link https://app.notion.com/p/output-sports/In-Product-Banners-3c30c9b3fff4809380fbd1fc804bed36
 */
export const BannerPriority = [
  Banner.RemoteAnnouncementBanner,
  Banner.SubscriptionPastDueBanner,
  Banner.SubscriptionUpcomingRenewalBanner,
  Banner.SubscriptionTrialBanner,
  Banner.LaunchBanner,
  Banner.HyroxConditioningTestBanner,
  Banner.HyroxOutputTiersBanner,
] as const;

export type BannerId = (typeof BannerPriority)[number];
